import React from "react";
import { BiLogOut } from "react-icons/bi";
import logout from "../../../utils/logout.js";
import "./AdminLogoutButton.scss";
import SettingsIcon from "../ControlIcons/SettingsIcon.jsx";
import UserIcon from "../ControlIcons/UserIcon.jsx";
import QuestionAnswerIcon from "../ControlIcons/QuestionAnswerIcon.jsx";
import LogsIcon from "../ControlIcons/LogsIcon.jsx";
import KeyIcon from "../ControlIcons/KeyIcon.jsx";
import { useAuthContext } from "../../../context/AuthContext";
import UsageIcon from "../ControlIcons/UsageIcon.jsx";

const LogoutButton = ({
  onSettingsClick,
  onUserManagementClick,
  onQAManagementClick,
  settingsVisible,
  FAQVisible,
  onLogsClick,
  onChangePasswordClick,
  handleUsageClick,
}) => {
  const { authUser } = useAuthContext();
  const canShowSettings = authUser?.isSuperAdmin || authUser?.canChangeConfig;

  // Function to process username
  const getDisplayName = (username) => {
    if (!username) return "Admin";
    const firstPart = username.split(".")[0]; // Split at the first `.`
    return firstPart.length > 15 ? firstPart.slice(0, 15) : firstPart; // Truncate if longer than 15
  };

  return (
    <div className="logout-container">
      <div className="logout-button">
        {/* Left Section: Username & Logout */}
        <div className="logout-button__section logout-button__left">
          <button className="user-info" onClick={onChangePasswordClick} title={`Change password for ${authUser?.username || "Admin"}`}>
            <KeyIcon />
            <span className={`logout-admin-username ${authUser?.isSuperAdmin ? "super-admin" : "regular-user"}`}>{getDisplayName(authUser?.username)}</span>
          </button>
          <div>
            <div className="logout-action" onClick={logout}>
              <BiLogOut className="logout-button__icon" />
              <p className="logout-button__text">Sair</p>
            </div>
          </div>
        </div>

        {/* Usage Icon */}
        {canShowSettings && <UsageIcon onClick={handleUsageClick} />}

        {/* Middle Section */}
        {(FAQVisible || settingsVisible) && <div className="logout-button__section logout-button__middle"></div>}

        {/* Right Section*/}
        {(FAQVisible || settingsVisible) && (
          <div className="logout-button__section logout-button__right">
            <>
              {(canShowSettings || authUser?.isSuperAdmin) && <SettingsIcon onClick={onSettingsClick} />}
              {settingsVisible && <UserIcon onClick={onUserManagementClick} />}
              {settingsVisible && <LogsIcon onClick={onLogsClick} />}
            </>
            <QuestionAnswerIcon onClick={onQAManagementClick} />
          </div>
        )}
      </div>
    </div>
  );
};

export default LogoutButton;
